import React from 'react'
import AddAdminUser from '../views/AddAdminUser'
import Sidebar from '../../components/Sidebar';

function AddAdminUserlayout() {
  return (
    <div className="flex min-h-screen">
      <div className="md:w-64 sm:w-32 bg-white shadow-md z-10"> 
        <Sidebar />
      </div>
      <div className="flex-1 p-4 bg-gray-100 overflow-x-auto"> 
        <AddAdminUser />
      </div>
    </div>
  )
}

export default AddAdminUserlayout
